import { editReviewParams, reviewReplyData, RVtrippy_campReview, RVtrippy_campReviewEditResponse, RVtrippy_campReviewReplyResponse, RVtrippy_campReviewResponse } from "./type_defs";

export const send_campReview_req = async (campID:number,rating:number,text:string) => {
	let success:boolean = false;
	let response:RVtrippy_campReviewResponse;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/submit_userReview",
		data: JSON.stringify({"camp_id": campID, "rating": rating, "review": text}),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			success = true;
			response = data;
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<RVtrippy_campReviewResponse>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const send_campReviewReply = async (reviewReplyData:reviewReplyData) => {
	let success:boolean = false;
	let response:RVtrippy_campReviewReplyResponse;
	let errMsg:string;

	await $.ajax({
		type:"post",
		url:"/reviewReply",
		data:JSON.stringify(reviewReplyData),
		contentType:'application/json',
		dataType:'json',
		success: (data) => {
			success = true;
			response = data;
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<RVtrippy_campReviewReplyResponse>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const send_review_edit = async (reviewID:string,rating:number,text:string) => {
	let success:boolean = false;
	let response:RVtrippy_campReviewEditResponse;
	let errMsg:string;

	let params:editReviewParams = {
		reviewID:reviewID,
		rating:rating,
		text:text,
		date: new Date()
	};

	await $.ajax({
		type: "post",
		url: "/editReview",
		data: JSON.stringify(params),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			response = data;
			success = true
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<RVtrippy_campReviewEditResponse>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const get_camp_info_reviews = async (campID:number) => {
	let success:boolean = false;
	let response:{reviews: Array<RVtrippy_campReview>, infoHTML: string};
	let errMsg:string;

	await $.ajax({
		type: "get",
		url: `./campDataAndReviewData/${campID}`,
		dataType: 'json',
		success: (data) => {
			success = true;
			response = data;
		},
		error: (xhr,err,exc) => {
			success = false;
			errMsg = err;
		}
	});

	return new Promise<{reviews: Array<RVtrippy_campReview>, infoHTML: string}>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const get_camp_reviews = async (campID:number) => {
	let success:boolean = false;
	let response:Array<RVtrippy_campReview>;
	let errMsg:string;

	await $.ajax({
		type: "get",
		url: `/campReview/${campID}`,
		dataType: 'json',
		success: (data) => {
			success = true;
			response = data;
		},
		error: (xhr,err,exc) => {
			success = false;
			errMsg = err;
		}
	});

	return new Promise<Array<RVtrippy_campReview>>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};